import { render, staticRenderFns } from "./Assesment.vue?vue&type=template&id=5c4cde3c&scoped=true"
import script from "./Assesment.vue?vue&type=script&lang=js"
export * from "./Assesment.vue?vue&type=script&lang=js"
import style0 from "./Assesment.vue?vue&type=style&index=0&id=5c4cde3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4cde3c",
  null
  
)

export default component.exports